/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * PT BR resource file
 */
export const labels = {
	title: "EY Canvas Economics",
	status: "Status",
	header: "Header",
	canvas: "Canvas",
	canvasEconomics: "Canvas Economics",
	badRequest: "bad request",
	errorBanner: "{0} Error(s)",
	userProfileDropdown: {
		myProfile: "My Profile",
		signOut: "Sair"
	},
	clientCode: "Código do cliente",
	hours: "Hours",
	local: "Local",
	currency: "Currencies",
	rate: "Rate",
	forecast: "Forecast",
	variance: "Variance",
	edit: "Edit",
	arrowUp: "Arrow UP",
	budget: "Budget",
	priorBudget: "Prior Budget",
	currentBudget: "Current Budget",
	summary: "Summary",
	actual: "Actual",
	priorActual: "Prior Actual",
	currentActual: "Current Actual",
	remaining: "Remaining",
	adjustment: "Adjustment",
	estimate: "Estimate",
	isRequired: "{0} is required",
	isPositiveInteger: "{0} is required and must be non-negative integer number.",
	isPositiveDecimal: "{0} is required and must be a positive number with 2 decimal places.",
	in: "In",
	id: "ID",
	currentYear: "Current Year",
	priorYear: "Prior Year",
	budgetHierarchy: "Budget hierarchy",
	executionBudgetHierarchy: "Execution budget hierarchy",
	noContentAvailable: "No content available",
	viewMore: "View More",
	budgetExecutionPhase: "Budget for all objects within {0}",
	details: "details",
	unallocated: "Unallocated",
	none: "None",
	thousands: "Thousands",
	millions: "Millions",
	lakhs: "Lakhs",
	crores: "Crores",
	budgetObjectName: "Budget Object Name",
	editActivityCodes: "Edit activity codes",
	save: "Save",
	send: "Enviar",
	cancel: "Cancel",
	searchActivityCodes: "Search Activity Codes",
	noActivityCodesAvailable: "No activity codes available",
	select: "Select",
	engagementCode: "Engagement code",
	engagementCodeName: "Nome do código do engagement",
	activityCode: "Activity code",
	activityCodeDescription: "Activity code description",
	searchActivityCodesPlaceholderText: "Search activity codes",
	addMember: "Add Member",
	closeLabel: "Close",
	cancelLabel: "Cancel",
	seachInputRequired: "Search input required",
	nameOrEmail: "Name or email",
	emailForExternal: "Email",
	noRecord: "No results found",
	userSearchPlaceholder: "Enter name or email and press enter to see results.",
	userSearchPlaceholderForExternal: "Enter email and press enter to see results.",
	clearAllValues: "Clear all values",
	clear: "Limpar",
	inValidEmail: "Please enter valid email",
	invalidClientCode: "Invalid client code",
	railSearchText: "Search",
	open: "Open",
	remove: "Remove",
	leave: "Sair",
	delete: "Excluir",
	markAsCompleted: "Mark as completed",
	budgetedHours: "Budgeted hours",
	forecastedHours: "Horários previstos",
	actualHours: "Actual hours",
	ftaVariance: "Variância de FTA",
	ftaVarianceTooltip: "Previsão de variância real",
	usedHours: "Horas utilizadas",
	etcHours: "ETC hours",
	createProjectCard: "Create Project",
	plusClients: "+{0} Clients",
	plusCodes: "+{0} Client codes ",
	clientNames: "Client Names: ",
	clientName: "Client Name: ",
	clientNameLabel: "Nome do cliente",
	clientCodes: "Client Codes: ",
	clientCodeCard: "Client Code: ",
	financialAnalysis: "Análises financeiras",
	billingExpenses: "Billing & expenses",
	independence: "Independência",
	timeChargedCanvasIndependenceStatus: "Status geral do projeto de independência pela EY Canvas e Código Financeiro",
	independenceStatusFromCanvasLabel: "Status de independência do EY Canvas",
	independenceRequired: "Independência requerida",
	validatedCanvas: "Validado no EY Canvas",
    notInvited: "Não convidado",
	notApplicable: "Não aplicável",
	incomplete: "Incompleto",
	other: "Outro",
	financialCodesDisplayed: "Códigos financeiros exibidos",
	independenceStatusChangeReasonLabel: "Alterar status",
	independenceStatusChangeReasonDescription: "Selecione o motivo da conclusão para o membro da equipe selecionado",
	changeReasonLabel: "Motivo",
	clarificationLabel: "Esclarecimento (opcional)",
	characterCount: "{0} de 200 caracteres",
	expandAll: "Expandir tudo",
	collapseAll: "Recolher tudo",
	canvasEngagements: "Engagements do EY Canvas",
	independenceCompleted: "Independência concluída",
	engagementName: "Nome do projeto",
	engagementIndependenceStatus: "Por status de independência do projeto",
	noAssociatedClients: "Nenhum cliente associado",
	noCanvasEngagementsIdentified: "Nenhum engagement do EY Canvas identificado",
	placeholderForSearch: "Pesquisar membro da equipe",
	exportToExcel: "Exportar para Excel",
	all: "Tudo",
	updateSelected: "Atualização selecionada",
	updateAll: "Atualizar tudo",
	customizeTable: "Personalizar tabela",
	canvasEngagementName: "Nome do engagement do EY Canvas",
	displayBy: "Display data by",
	financialDetails: "Financial details",
	actualHoursToDate: "Horas reais até o momento",
	byWeekEndingDate: "por data de término da semana",
	ClickAndDrag: "Clique e arraste uma área no gráfico para ampliar",
	etc: "Tempo estimado para completar",
	auditProgress: "Progresso do EY Canvas",
	tasksAndMilestones: "Tarefas e Milestones",
	milestonesOverdue: "Milestones em atraso",
	milestoneOverdue: "milestones vencidos",
	inProgress: "Em andamento",
	inReview: "Em revisão",
	Complete: "Completo",
	assignments: "Atribuições",
	assignment: "atribuições",
	assignmentsOverdue: "Atribuições atrasadas",
	assignmentOverdue: "atribuições vencidas",
	overdue: "atrasado",
	requestOverdue: "Pedido vencido ",
	requestsOverdue: "Pedido vencido ",
	total: "total",
	complete: "completo",
	closed: "Fechado",
	Unassigned: "Não-atribuído",
	unassigned: "não atribuído ",
	sent: "enviado",
	totalTask: "Tarefa Total",
	collaboration: "Colaboração",
	received: "recebido",
	accepted: "Aceito",
	outstanding: "Pendente",
	unsentDrafts: "Rascunhos não-enviados",
	draft: "Draft",
	drafts: "drafts",
	returned: "devolvido",
	draftRequests: "drafts solicitados",
	percent: "por cento",
	preparer: "Preparador",
	reviewer: "Revisor",
	NoDataForSelectedOptions: "Nenhuma informação disponível para as opções selecionadas. ",
	NoAssignmentDataForSelectedOptions: "Engagement não está utilizando o recusro Atribuição",
	NoCollabDataForSelectedOptions: "O engagement não está utilizando o recurso Colaboração",
	tasks: "Tarefas",
	totalTasks: "tarefas totais",
	requests: "solicitações",
	requestSent: "pedidos enviados ",
	requestsSent: "Pedidos enviados",
	expandDetails: "Expandir detalhes",
	onlyProjectAdministratorsCanEdit: "Apenas os administradores do projeto podem editar",
	onlyProjectAdministratorsCanDelete: "Apenas os administradores do projeto podem excluir projetos",
	userOptions: "Opções do usuário",
	userOptionsDropdown: {
		userSettings: "Configurações do usuário",
		delegateAccess: "Gerencie delegados",
		privacyNotice: "Aviso de privacidade",
		signOut: "Sair"
	},
	delegateToInstruction: "Delege o acesso aos colegas, para que eles possam validar códigos do engagement em seu nome. Esses delegados poderão validar todos os códigos dos engagements que você tem acesso.",
	delegateFromInstruction: "Os seguintes usuários delegaram seus direitos para validar códigos do engagement.",
	delegateAccess: "Gerencie delegados",
	addDelegates: "Adicionar delegados",
	addAnother: "Adicionar novo delegado",
	hideMyDelegate: "Esconda meus delegados.",
	showMyDelegate: "Mostre meus delegados",
	duplicateUser: "Delegado já adicionado",
	informationRequired: "Essas informações são necessárias",
	delegateTo: "Delegado para",
	delegateFrom: "Delegado de",
	noDelegatesAdded: "Nenhum delegado adicionado.",
	noDelegationReceived: "Nenhuma delegação foi recebida.",
	removeDelegateMessgae: "Tem certeza que quer remover esse delegado? Uma vez removidos, eles não poderão mais validar códigos de engagements financeiro em seu nome.",
	removeDelegateTitle: "Remova um delegado",
	delegate: "Delegar",
	saveAndClose: "Salvar & fechar",
	resetZoom: "Redefinir zoom",
	exportData: "Dados de exportação",
	rankCode: "Código de classificação",
	userGui: "Gui do usuário",
	email: "Email",
	globalAnsr: "Global ANSR",
	globalCost: "Custo global",
	globalMargin: "Margem global",
	localAnsr: "Local ANSR",
	localCost: "Custo local",
	localMargin: "Margem local",
	weekEnding: "Fim da semana",
	welcomeToEconomics: "Bem-vindo ao EY Canvas Economics ",
	adminPortal: "portal administrativo",
	home: "Início",
	enterFirstNameText: "Digite o nome, sobrenome ou endereço de e-mail do usuário e pressione enter para pesquisar ",
	addBtn: "Adicionar",
	cancelBtn: "Cancelar",
	close: "Fechar",
	selectRole: "Função",
	upsText: "'Ups!",
	sufficientRightsToAccess: "Você não tem direitos suficientes para acessar esta página ",
	detailedInformation: "As informações detalhadas podem variar entre resumo de dados apresentados devido as diferenças na época de quando os dados foram disponibilizados. ",
	noResultFound: "Nenhum resultado corresponde aos critérios de pesquisa ",
	loading: "Carregando…",
	search: "Procurar",
	softwareUpdate: "Atualizações de software",
	updateLater: "Atualizar depois",
	updateNow: "Atualizar agora",
	updateMsg: "Atualizações de software estão disponívels pelo EY Canvas Economics. Selecione Atualizar Agora para baixar e instalar todas as atualizações. A página será atualizada.",

	eycanvasEngagements: "Engagements do EY Canvas",
	eycanvasEngagement: "Engagement do EY Canvas",
	expandView: "Expandir visualização",
	noFinancialCodesDisplay: "Nenhum código financeiro para exibir",
	expand: "Expandir",
	collapse: "Colapsar",
	bulkSendIndependenceLabel: "Envio em massa de confirmação de independência",
	independenceStatusInviteUserLabel: "Adicionar membro interno da equipe somente para Independência",
	independenceStatusInviteUserDescription: "Identifique a função do membro da equipe abaixo. Este usuário será adicionado ao engagement do {0} Canvas com as restrições 'Somente para independência' e será notificado para concluir sua independência.",
	clickToInviteUser: "para enviar confirmação de independência",
	click: "Clicar",
	invitePending: "Convite pendente",
	engagementRolePlaceholder: "Função do Engagement",
	engagementRoleRequiredErrorMessage: "Por favor selecione a função do Engagement para o membro da equipe selecionado",
	engagementInvitationSuccessToastMessage: "Você enviou com sucesso a(s) confirmação(ões) de independência.",
	engagementInvitationFailureToastMessage: "Falha ao enviar a(s) confirmação(ões) de independência. Por favor, tente novamente. Se o problema persistir, entre em contato com o Help Desk.",
	independenceInviteConfirmationMessage: "A confirmação da independência foi enviada. A resposta está pendente.",
	engagementRoleRequiredOverAllErrorMessage: "Uma função do Engagement não foi selecionada para um ou mais usuários. Selecione a função do engagement no menu suspenso para prosseguir com o envio da confirmação de independência.",
	administrativeContractor: "Contratante Administrativo",
};

export const errors = {
	default: "Ocorreu um erro. Entre em contato com helpdesk.",
	102: "Projeto Inválido.",
	106: "Autorização da RBAC negada.",

	1001: "User not found.",
	1002: "User GetAll call failed.",
	1003: "User GUI can not be null.",
	1004: "Request can not be null.",
	1005: "User couldnt be created because a user with the same GUI already exists.",
	1006: "More than one user with the same GUI was found.",
	1007: "The user is not active. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1008: "The selected number format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1009: "The selected rounding format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1010: "The selected currency format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1011: "The selected date format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1012: "The selected language is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1013: "The first name is either too short or too long. Please try again.",
	1014: "The last name is either too short or too long. Please try again.",
	1015: "The selected negative number format is not a valid one. Please refresh the page and try again. If the error persists, please contact the Help Desk.",
	1016: "The User couldnt be updated because it doesnt exist.",
	1017: "An error has occured while getting the user preferences. The API Call has failed.",
	1018: "An error has occured while creating the user. The API Call has failed.",
	1019: "An error has occured while updating the user preferences. The API Call has failed.",
	1020: "O usuário não está ativo. Atualize a página e tente novamente. Se o erro persistir, entre em contato com o Help Desk.",
	1021: "O valor do tema selecionado não é válido. Por favor, atualize a página e tente novamente. Se o erro persistir, entre em contato com o Help Desk.",
	1022: "O valor da moeda selecionada não é válido. Por favor, atualize a página e tente novamente. Se o erro persistir, entre em contato com o Help Desk.",
	1023: "O usuário não está autorizado a remover o membro da equipe solicitado do projeto.",
	1024: "Ocorreu um erro ao criar o usuário delegado. A chamada API falhou.",
	1025: "A lista de usuários do delegado não deve estar vazia.",
	1026: "O nome de um usuário é muito longo ou muito curto.",
	1027: "A GUI de um usuário é inválido.",
	1028: "O endereço de e-mail de um usuário é muito longo ou muito curto.",
	1029: "A identificação do usuário não deve estar vazia.",
	1030: "O nome do usuário não deve estar vazio.",
	1031: "O endereço de e-mail do usuário não deve estar vazio.",
	1032: "O usuário não faz parte da coleta para remover o acesso.",
	1033: "O usuário não faz parte do delegado da coleta para remover o acesso.",
	1034: "O usuário já faz parte do delegado para a coleta.",
	1035: "O comprimento do ID do usuário não é apropriado. Por favor, tente novamente com o usuário correto.",
	1036: "O usuário logado não pode fazer parte da lista. Por favor, tente novamente mais tarde.",
	1040: "Você não tem direitos de administrador. Por favor entre em contato com o help desk.",

	7001: "Engagements metadata call failed.",
	7006: "EY Canvas is not accessible at this time. Refresh the page and try again. If the issue persists, contact the Help Desk.",

	8003: "Error while getting Engagement Details from CDS API.",
	8006: "EY Canvas is not accessible at this time. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	8004: "Código de engagement não encontrado. Se este for um código Mercury, certifique-se de que o Tipo de Engagement foi incluído.  Tente novamente e se o problema persistir, entre em contato com o Help Desk.",
	8007: "Erro ao obter detalhes do envolvimento da API CDS.",
	8008: "Falha na conexão. Atualize e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

	9001: "Pedido não pode ser nulo",
	9002: "O campo do Código do Cliente do Projeto não pode ser nulo",
	9003: "O campo Project Name não pode ser nulo.",
	9004: "O campo percentual não pode ser nulo.",
	9005: "O campo de taxa não pode ser nulo.",
	9006: "O orçamento não tem nenhum engagement selecionado associado.",
	9007: "O identificador exclusivo do engagement não pode ser nulo.",
	9008: "O nome do cliente do engagement não pode ser nulo.",
	9009: "A descrição do engagement não pode ser nula.",
	9010: "O identificador exclusivo do cliente do engagement não pode ser nulo.",
	9011: "O sistema do engagement relacionado não pode ser nulo.",
	9012: "O identificador exclusivo do engagement relacionado não pode ser nulo.",
	9013: "O nome do engagement relacionado não pode ser nulo.",
	9014: "O identificador exclusivo do cliente de engajamento relacionado não pode ser nulo.",
	9015: "O nome do cliente do engagement relacionado não pode ser nulo.",
	9016: "O engagement relacionado adicionado não pode ser nulo.",
	9017: "Um ou mais engagements do EY Canvas são inválidos.",
	9018: "Um ou mais Códigos dos engagements relacionados são inválidos.",
	9019: "Percentual de projetos deve ser maior que zero.",
	9020: "Percentual de projetos não deve ter mais de dois dígitos decimais.",
	9021: "A taxa de projetos deve ser maior que zero.",
	9022: "Id do projeto é inválido.",
	9023: "Falha na chamada para análises financeiras.",
	9024: "Detalhes do projeto não encontrados.",
	9025: "A chamada para cabeçalho falhou.",
	9026: "Nenhum resultado corresponde aos critérios de pesquisa.",
	9027: "Tipo de agregação inválida.",
	9028: "O usuário atual não tem acesso ao projeto.",
	9029: "Detalhes de faturamento do projeto não encontrados.",
	9030: "Filtros Financeiros do projeto não encontrados.",
	9031: "O nome de um usuário é muito longo ou muito curto.",
	9032: "A GUI de usuários é inválida.",
	9033: "Um endereço de e-mail dos usuários é muito longo ou muito curto.",
	9034: "Pelo menos um membro da equipe deve ter função de administrador do projeto.",
	9035: "Você é o último usuário administrador do projeto ativo. Exclua o projeto para removê-lo de sua página inicial. Se você não conseguir excluir o projeto, entre em contato com o Help Desk. ",
	9036: "Remova um ou mais engagements do EY Canvas. A quantidade excede o {0}.",
	9037: "Por favor, remova alguns membros da equipe porque a quantidade excede os {0}.",
	9038: "Por favor, remova alguns códigos de engajamento porque a quantidade excede os {0}.",
	9039: "A contagem de usuários do projeto deve ser maior que zero.",
	9040: "Os códigos financeiros não validados não devem ser strings nulas ou vazias e seu engagement não pode ultrapassar 50 caracteres.",
	9041: "A id do projeto não deve estar vazio.",
	9042: "Não é possível concluir a exclusão. Tente novamente e se o erro persistir, entre em contato com o Help Desk.",
	9043: "O usuário atual não tem acesso para editar um projeto. ",
	9044: "Falha na chamada de detalhes financeiros do projeto. ",
	9045: "O status do projeto não é válido.",
	9046: "O status do usuário do projeto não é válido.",
	9047: "Função de usuário do projeto inválida.",
	9048: "O nome do projeto deve ter no máximo 500 caracteres.",
	9049: "O nome do usuário do projeto não pode ficar vazio.",
	9050: "O sobrenome do usuário do projeto não pode ficar vazio.",
	9051: "A GUI do usuário do projeto não pode estar vazia.",
	9052: "O e-mail do usuário do projeto não pode ficar vazio.",
	9053: "A bandeira administrativa do usuário do projeto não pode estar vazia.",
	9054: "A conta privilegiada não pode ser adicionada como usuário do projeto.",
	9055: "Filtros de despesas do projeto não encontrados.",
	9056: "O corpo da solicitação do patch de independente do projeto não pode estar vazio.",
	9058: "Os códigos financeiros são inválidos.",
	9063: "Independência concluída tem valor de justificativa inválido.",
	9064: "O tipo de independência concluída tem valor inválido.",
	9065: "Filtros de despesas do projeto não encontrados.",
	9066: "O número de IDs de engagements vinculados ao projeto é maior que o número máximo permitido.",
	9067: "Operação de patch inválida.",
	9068: "Algum usuário já atualizou o status, atualize a página para visualizar o status mais recente.",
	9069: "Falha na API do patch de independência.",
	9070: "Códigos financeiros duplicados associados ao engagement do Canvas.",
	9071: "Somente códigos financeiros únicos associados ao engagement do canvas podem ser marcados como código primário.",
	9072: "Os códigos financeiros primários associados ao engagement do canvas são inválidos.",
	9073: "Códigos financeiros não validados duplicados.",
	9074: "Usuários duplicados.",
	9075: "Um e-mail de usuário é inválido.",
	9076: "O corpo da solicitação do criador do usuário do Engagement não pode estar vazio.",
	9077: "A solicitação de criação de usuário de engagement tem usuários duplicados.",
	9078: "A função de usuário do Engagement está inválida.",
	9079: "Engagement do canvas inválido.",
	9080: "Engagement não mapeado para o projeto.",
	9081: "Falha na solicitação de criação de usuário do Engagement.",
	9082: "A sessão expirou devido à inatividade. Atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk.",

	/*Admin error codes*/
	14001: "Usuário não encontrado",
	14002: "Falha na chamada do usuário administrador ",
	14003: "O usuário administrador encontrado está inativo ",
	14004: "Falha na criação do usuário administrador ",
	14005: "O primeiro nome é muito curto ou muito longo. Por favor, tente novamente ",
	14006: "O último nome é muito curto ou muito longo. Por favor, tente novamente ",
	14007: "O ID da função de administrador é inválido ",
	14008: "O usuário selecionado já é um administrador. Por favor revise. ",
	14009: "Falha na chamada de pesquisa do usuário administrador ",
	14010: "O gui do usuário não pode estar vazio",
	14011: "O gui do do usuário deve ser maior que zero ",
	14012: "O ID do usuário não é válido. Por favor, tente novamente ",
	14013: "O endereço de email não é válido. Por favor, tente novamente",
	14014: "Usuário logado não é igual ao usuário administrador ",
	14015: "Falha na chamada de pesquisa do projeto de administrador ",
	14016: "O usuário administrador já existe mas está inativo ",
	14017: "O administrador só pode ser uma conta de usuário privilegiada",
	14018: "O ID da função de administrador não pode estar vazio.",
	14019: "O usuário conectado não é administrador do sistema.",
	14020: "Conta privilegiada do solicitante inválida.",
	14021: "O administrador só pode ser uma conta de usuário privilegiada.",
	14023: "Erro ao remover funções de administrador existentes.",
	14024: "Erro ao adicionar funções de administrador atualizadas.",
	14025: "O ID do usuário administrador não pode estar vazio.",

	/*PAANS error codes*/
	15001: "O EY Policy Authoring, Approvals and Notification Service​ está indisponível no momento. Não podemos confirmar se todas as políticas relevantes foram concluídas. Se você não revisou as políticas relevantes, atualize a página e tente novamente. Se o problema persistir, entre em contato com o Help Desk."
};

export const roundingOptions = [{
	value: 'none',
	label: "nenhum"
},
{
	value: 'thousands',
	label: "Em milhares"
},
{
	value: 'millions',
	label: "Em milhões"
},
{
	value: 'lakhs',
	label: "Em lakhs"
},
{
	value: 'crores',
	label: "Em crores"
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: "Inglês",
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: "Francês",
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: "Espanhol",
	value: 'es'
},
{
	displayLanguageId: 7,
	label: "Português",
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: "Japonês",
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: "Zh-cn chinês",
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: "Zh-tw chinês",
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: "Hebraico",
	value: 'he'
},
{
	displayLanguageId: 12,
	label: "Coreano",
	value: 'ko'
}
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: "numbericStlye1",
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: "numbericStlye3",
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: "numbericStlye7",
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: "numbericStlye2",
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: "global",
	label: "Global"
},
{
	value: "local",
	label: "Local"
}
];

export const themeOptions = {
	light: "Light",
	dark: "Dark"
};

export const currencyOptions = {
	global: "Global",
	local: "Local"
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: "Global"
},
{
	value: 'Local',
	label: "Local"
}
];

export const statusValues = [{
	isActive: true,
	label: "Ativo"
},
{
	isActive: false,
	label: "Inativo"
}
];

export const financialOptions = {
	serviceLine: "Linha de serviço",
	subServiceLine: "Sub-linha de serviço",
	teamMember: "Membro do time",
	rank: "Classificação"
};

export const roles = {
	1: "Partner in Charge",
	2: "Engagement Partner",
	3: "Executive Director",
	4: "Principal",
	5: "Senior Manager",
	6: "Manager",
	7: "Senior",
	8: "Staff",
	9: "Intern",
	10: "Engagement Quality Reviewer",
	11: "Other Partner",
	12: "GDS - Staff",
	13: "Advisory (ITRA,TAS,Human Capital or Other)",
	14: "Tax",
	15: "Executive Support Services",
	16: "General Counsel",
	17: "Audit Quality Reviewer",
	21: "Internal Audit Supervisor",
	22: "Internal Audit Staff",
	23: "Regulator",
	24: "Other (e.g. due diligence review)",
	25: "Office",
	26: "Area",
	27: "Industry",
	28: "National",
	29: "Global",
	30: "GDS - Senior",
	31: "GDS - Manager"
};

export const serviceLines = [{
	value: 0,
	label: "Todas as linhas de serviço"
},
{
	value: 1,
	label: "Advisory"
},
{
	value: 2,
	label: "Assurance"
},
{
	value: 3,
	label: "GCO"
},
{
	value: 4,
	label: "TAS"
},
{
	value: 5,
	label: "TAX"
},
{
	value: 6,
	label: "Other"
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: "Não disponível"
},
{
	code: 'ASU',
	label: "Assurance"
},
{
	code: 'TAS',
	label: "Estratégia e transações "
},
{
	code: 'TAX',
	label: "Imposto"
},
{
	code: 'ADV',
	label: "Consultoria"
},
];

export const userRanks = [{
	id: '11',
	name: "Sócio"
},
{
	id: '12',
	name: "Sócio"
},
{
	id: '13',
	name: "Diretor Executivo"
},
{
	id: '21',
	name: " Gerente Sr."
},
{
	id: '32',
	name: "Gerente"
},
{
	id: '36',
	name: "Gerente de Impostos"
},
{
	id: '4',
	name: "Terceiro"
},
{
	id: '41',
	name: "Sênior 3"
},
{
	id: '42',
	name: "Sênior"
},
{
	id: '43',
	name: "Staff 2"
},
{
	id: '44',
	name: "Staff"
},
{
	id: '45',
	name: "Sênior 2"
},
{
	id: '46',
	name: "Staff 3"
},
{
	id: '49',
	name: "Associado"
},
{
	id: '5',
	name: "Empreiteiro administrativo"
},
{
	id: '51',
	name: "Interno"
},
{
	id: '52',
	name: "Suporte administrativo"
},
{
	id: '53',
	name: "Interno (CBS)"
},
{
	id: '55',
	name: "Líder Administrativo "
},
{
	id: '56',
	name: "Administrador Avançado"
},
{
	id: '57',
	name: "Administrador Intermediário"
},
{
	id: '58',
	name: "Entrada do administrador"
},
{
	id: '61',
	name: "Diretor"
},
{
	id: '62',
	name: "Diretor Associado"
},
{
	id: '63',
	name: "Diretor Assistente"
},
{
	id: '64',
	name: "Supervisor Associado"
},
{
	id: '65',
	name: " Associado Sr."
},
{
	id: '66',
	name: "Associado"
},
{
	id: 'Not available',
	name: "Não disponível"
}
];

export const financialAnalysis = {
	noResultFound: "Não foram encontrados resultados para as opções selecionadas",
	allServiceLines: "Todas as linhas de serviço",
	allSubServiceLines: "Todas as sub-linhas de serviço",
	allMembers: "Todos os membros",
	allAvailable: "Todos disponíveis",
	allAdded: "Tudo adicionado",
	selectAll: "Selecione todos",
	noResult: "Nenhum resultado encontrado",
	noneSelected: "Nenhum selecionado",
	clearAllSeleted: "Limpar # selecionado",
	showSelected: "Mostrar selecionado",
	allRanks: "Todas as classificações "
};

export const independenceStatus = [{
	value: 1,
	label: "Incompleto - Não convidado"
},
{
	value: 2,
	label: "Incompleto - Em andamento"
},
{
	value: 3,
	label: "Concluído - Outro"
},
{
	value: 4,
	label: "Concluído - Validado no EY Canvas"
}
];

export const eycanvasIndependenceStatus = [{
	value: 1,
	label: "Incompleto"
},
{
	value: 2,
	label: "Nenhum assunto identificado"
},
{
	value: 3,
	label: "Assunto identificado - Ação pendente"
},
{
	value: 4,
	label: "Assunto resolvido - Acesso negado"
},
{
	value: 5,
	label: "Assunto resolvido - Acesso concedido"
},
{
	value: 6,
	label: "Não aplicável"
},
{
	value: 7,
	label: "Restaurado"
},
{
	value: 8,
	label: "Sobrepor"
},
{
	value: 9,
	label: "Anterior - Nenhum assunto identificado"
},
{
	value: 10,
	label: "Anterior - Assunto Identificado - Ação Pendente"
},
{
	value: 11,
	label: "Anterior - Assunto resolvido - Acesso concedido"
},
{
	value: 12,
	label: "Anterior - Assunto resolvido - Acesso negado"
}
];

export const availableUserRoles = [{
	value: 1,
	label: "Sócio Responsável",
	displayOrder: 9
},
{
	value: 2,
	label: "Sócio do Engagement",
	displayOrder: 8
},
{
	value: 3,
	label: "Diretor-executivo",
	displayOrder: 5
},
{
	value: 4,
	label: "Diretor",
	displayOrder: 6
},
{
	value: 5,
	label: "Gerente Sênior",
	displayOrder: 4
},
{
	value: 6,
	label: "Gerente",
	displayOrder: 3
},
{
	value: 7,
	label: "Sênior",
	displayOrder: 2
},
{
	value: 8,
	label: "Staff",
	displayOrder: 1
},
{
	value: 10,
	label: "Revisor de Qualidade do Engagement",
	displayOrder: 10
},
{
	value: 11,
	label: "Outro Sócio",
	displayOrder: 7
},
{
	value: 12,
	label: "GDS - Staff",
	displayOrder: 13
},
{
	value: 16,
	label: "Conselho Geral",
	displayOrder: 12
},
{
	value: 17,
	label: "Revisor de Qualidade de Auditoria",
	displayOrder: 11
},
{
	value: 30,
	label: "GDS - Sênior",
	displayOrder: 14
},
{
	value: 31,
	label: "GDS - Gerente",
	displayOrder: 15
}
]

export const employmentStatus = [{
	value: 'A',
	label: "Ativado"
},
{
	value: 'D',
	label: "Terminado"
},
{
	value: 'L',
	label: "Licença por Ausência"
},
{
	value: 'T',
	label: "Terminado"
},
{
	value: 'P',
	label: "Licença por Ausência"
},
{
	value: 'R',
	label: "Terminado"
},
{
	value: 'U',
	label: "Licença por Ausência"
},
]

export const independenceStatusDropdown = [{
	label: "Incompleto",
	options: [{
		value: 1,
		label: "Incompleto - Não convidado"
	},
	{
		value: 2,
		label: "Incompleto - Em andamento"
	}
	]
},
{
	label: "Concluído",
	options: [{
		value: 3,
		label: "Concluído - Outro"
	}]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: "Status de independência do EY Canvas"
},
{
	id: 3,
	label: "Firma membro"
},
{
	id: 4,
	label: "País"
},
{
	id: 5,
	label: "Horas cobradas"
},
{
	id: 6,
	label: "Status geral de independência"
},
{
	id: 7,
	label: "Data de confirmação"
},
{
	id: 8,
	label: "Situação de emprego"
},
{
	id: 9,
	label: "Atualizado por"
},
{
	id: 10,
	label: "Data atualizada"
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: "Concluído fora do EY Canvas - Nenhum assunto identificado",
	isDisplayed: true
},
{
	value: 7,
	label: "Concluído fora do EY Canvas - Questões Identificadas",
	isDisplayed: true
},
{
	value: 8,
	label: "Concluído fora do EY Canvas - Questões resolvidas",
	isDisplayed: true
},
{
	value: 2,
	label: "Sempre uma pessoa coberta",
	isDisplayed: true
},
{
	value: 3,
	label: "Não está mais na firma",
	isDisplayed: true
},
{
	value: 4,
	label: "Licença de Ausência",
	isDisplayed: true
},
{
	value: 5,
	label: "Terminado",
	isDisplayed: false
},
{
	value: 6,
	label: "Outro",
	isDisplayed: false
}
];

export const common = {
	selected: "Selecionado",
	cancel: "Cancelar",
	checkbox: {
		selectAllOn: "Selecione todos",
		selectAllOff: "Desmarque todos"
	},
	clear: "Limpar",
	close: "Fechar",
	nav: {
		projectName: "Nome do projeto"
	},
	pagination: {
		show: "Show",
		iconHover: {
			first: "First Page",
			previous: "Previous Page",
			next: "Next Page",
			last: "Last Page"
		}
	},
	search: {
		clear: "Limpar busca",
		buttonTitle: "Busca",
		placeholder: "Procurar",
		noResultsPlaceholder: "Nenhum resultado encontrado"
	},
	table: {
		remove: "Remover",
		noDataPlaceholder: "Não há dados disponíveis",
		noResultsPlaceholder: "Nenhum resultado encontrado"
	},
	toggleSwitch: {
		no: "Não",
		yes: "Sim"
	},
	wizard: {
		next: "Continuar",
		back: "Voltar",
		finish: "Encerrar"
	},
	unsavedChanges: "Alterações não salvas",
	unsavedChangesDescription: "Você tem alterações não salvas que serão perdidas se você optar por continuar. Tem certeza de que deseja desfazer suas alterações?"
};

export const project = {
	myProjects: "Meus projetos",
	priorProjects: "Prior Projects",
	searchForBudgets: "Procurar",
	emptyContainer: "You do not have any active budget. Click 'Create budget' to get started.",
	noResultsFound: "Nenhum resultado encontrado.",
	create: {
		title: "Create project",
		clientCode: "Client code",
		clientCodeInfo: "Mirror codes are not recognized. Use the code from the system that issued the code (i.e., Mercury or GFIS).",
		clientName: "Client name",
		clientNamePlaceholder: "Enter client code to look up client name",
		name: "Project name",
		rate: "Default rate per hour",
		rateInfo: "The default rate per hour will be used to calculate the value of budgeted hours. This rate should be calculated as the fees to be bills divided by total expected hours.",
		percentage: "Expected realization percentage",
		percentageInfo: "The expected realization percentage will be applied to the time value of hours charged in Mercury or GFIS.",
		relateEngagementsInstructionalText: "Select one or more EY Canvas engagements that will be used in this project. Metrics from these engagements will be presented alongside financial data. Only engagements currently accessible will be displayed.",
		selectClientAndWorkspaceInstructionalText: "Select a client and workspace to identify EY Canvas engagements that will be related to this project.",
		engagementPanelPlaceholder: "Select a client and workspace to show suggested engagements.",
		engagementPanelNoResultsFound: "Nenhum resultado encontrado",
		emptyEngagements: "No EY Canvas engagements available. Create a new engagement in EY Canvas to get started.",
		selectClient: "Select client",
		selectWorkspace: "Select workspace",
		selectEngagements: "Select engagement",
		selectedEngagements: "Added engagements",
		selectedEngagementError: "Select one or more engagements to continue",
		searchEngagements: "Search engagements",
		searchUsers: "Search users",
		engagementLabel: "{0} | ID: {1}",
		addBtn: "Add",
		removeBtn: "Remove",
		clientLbl: "Client",
		engagementCodeLbl: "Engagement code",
		engagementTypeCodeLbl: "Engagement type",
		engagementNameLbl: "Engagement name",
		engagementId: "ID",
		addedByLbl: "Added By",
		engagementDescriptionLbl: "Engagement description",
		systemLbl: "System",
		noEngagementsLabel: "Relate Engagement codes to this project.",
		step4InstTxt: "Selecione um ou mais códigos de engagements a serem associados ao projeto.",
		relatedEngagementCodesSubtitle: "Related Engagement Codes",
		relatedEngagementCodeLink: "Relate engagement code from Mercury or GFIS. Mirror codes are not recognized.",
		unauthorizedModalHeader: "Unauthorized user",
		unauthorizedText: "You are not authorized to relate",
		allowedUsersText: "A seguir está uma lista de pessoas que podem realizar esta ação. ",
		closeBtn: "Fechar",
		validateBtn: "Validate",
		relatedEngagementAddLabel: "Relate engagement code from from Mercury or GFIS. Mirror codes are not recognized.",
		todayLbl: "Today",
		NoEmailMessage: "No email provided",
		noEngagementsAdded: "No engagements added",
		selectToImport: "Select an EY Canvas engagement to import users to this project.",
		addMember: "Se um usuário não estiver ativo no engagement do EY Canvas, {0} para adicioná-lo.",
		addedMembers: "Added members",
		employeeName: "Member",
		role: "Role",
		manageTeamInstructionalText: "Select active team members from the related EY Canvas engagements, follow the description below to add other team members not part of the EY Canvas engagements.",
		currentUser: "Current user",
		canvasEngagements: "Engagements do EY Canvas",
		wizardSteps: [
			{
			stepName: "Step 1",
			stepDescription: "Enter project details",
			active: true
		},
		{
			stepName: "Step 2",
			stepDescription: "Selecione os engagements do EY Canvas"
		},
		{
			stepName: "Step 3",
			stepDescription: "Manage access",
			relatedEngagementCodesSubtitle: "Related Engagement Codes",
			relatedEngagementCodeLink: "Relate engagement code from Mercury or GFIS. Mirror codes are not recognized.",
			unauthorizedModalHeader: "Unauthorized User",
			unauthorizedText: "You are not authorized to relate",
			allowedUsersText: "Following are a list of individuals who can take this action.",
			close: "Fechar"
		},
		{
			stepName: "Step 4",
			stepDescription: "Conecte-se ao Mercury/GFIS"
		},
		{
			stepName: 'Step 5',
			stepDescription: "Associar códigos de engagement aos engagements do EY Canvas",
			isExit: true
		}
		],
		ratePerHour: "Rate per hour",
		realizationPercentage: "Realization percentage"
	},
	stepOne: {
		enterProjectName: "Enter a project name to continue"
	},
	stepTwo: {
		addCanvasEngagements: "Adicionar os engagement do EY Canvas no projeto",
		editCanvasEngagements: "Editar os engagements do EY Canvas no projeto",
		selectCanvasEngagements: "Os engagements do EY Canvas aos quais você tem acesso são exibidos. Selecione um ou mais engagements do EY Canvas para serem incluídos no projeto.",
		noCanvasEngagements: "Não há engagements do EY Canvas disponíveis. Prossiga para a próxima etapa para continuar a configuração do projeto.",
		noCanvasEngagementsSelected: "Nenhum engagement do EY Canvas foi selecionado",
		noSearchResultsFoundLeftRail: "Nenhum resultado encontrado",
		clientName: "Cliente",
		workspace: "Área de trabalho",
		engagementCode: "Código do engagement",
		canvasEngagementName: "Engagement do EY Canvas",
		changes: "Alterações",
		tooltipMessages: {
			clientName: "Nome do cliente",
			clientCode: "Código do Cliente",
			engagementCode: "Código de Engagement",
			engagementDescription: "Nome do Engagement",
			workspaceID: "ID da área de trabalho",
			workspaceDescription: "Nome da área de trabalho"
		}
	},
	stepThree: {
		editTeamMembers: "Editar os membros da equipe para o projeto",
		editTeamMembersWhoWillHaveAccess: "Editar membros da equipe que terão acesso ao projeto. Para adicionar um membro da equipe que não faz parte dos engagements associados ao EY Canvas, use o recurso de pesquisa no lado direito. Os administradores do projeto poderão gerenciar o projeto (por exemplo, adicionar ou remover membros da equipe).",
		addTeamMembers: "Adicione membros da equipe ao projeto",
		addTeamMembersWhoWillHaveAccess: "Adicione membros da equipe que terão acesso ao projeto. Para adicionar um membro da equipe que não faz parte dos engagements associados ao EY Canvas, use o recurso de pesquisa no lado direito. Os administradores do projeto terão a capacidade de gerenciar o projeto (por exemplo, adicionar ou remover membros da equipe).",
		noCanvasEngagementsSelected: "Nenhum engagement do EY Canvas foi selecionado",
		noSearchResultsFoundLeftRail: "Nenhum resultado encontrado",
		addOtherTeamMembers: "Adicione outros membros da equipe que não fazem parte dos engagements do EY Canvas conectados",
		member: "Membro",
		projectAdministrator: "Administrador de projetos",
		clickHere: "clique aqui",
		nameOrEmail: "Nome ou e-mail",
		addNewMember: "Adicionar",
		firstName: "Primeiro nome",
		lastName: "Último nome",
		inviteAndClose: "Convidar e fechar",
		inviteAndAddAnother: "Convide e adicione outro",
		clear: "Limpar"
	},
	stepFour: {
		engagementCode: "Código do engagement",
		clientName: "Cliente",
		validation: "Status",
		independenceOnly: "Independência apenas",
		noEngagementCodes: "Sem códigos dos engagements adicionados ao projeto",
		addNewMember: "Adicionar",
		addEngagementManually: "Adicionar códigos do engagement",
		addEngagementCodes: "Adicionar códigos do engagement",
		editEngagementCodes: "Editar códigos dos engagements",
		validateEngagement: "Valide todos os códigos de projetos adicionados. Somente os códigos de projetos aos quais você tem acesso no GFIS/Mercury podem ser validados. Se um código de projeto for identificado como \'Apenas independência\', os detalhes relacionados a esse código de projeto (como membros da equipe e horas relacionadas cobradas) serão incluídos no resumo de independência deste projeto de economia, mas não serão incluídos no relatório financeiro em formação.",
		informationalMessage: "Para Mercury, inclua o tipo de engagement prefixado ao código de engagement (por exemplo, E-12345678)",
		noCanvasEngagements: "Nenhum engagement do EY Canvas foi adicionado ao projeto",
		engagementCodePlaceholder: "Digite um código do engagement",
		validate: "Validar",
		engagementCodeRequired: "Código do engagement necessário",
		searchNoResults: "Nenhum resultado encontrado"
	},
	stepFive: {
		title: "Associar códigos de engagement aos projetos do EY Canvas",
		description: "Os códigos de engagement primários associados a cada um dos engagements do EY Canvas conectados são exibidos abaixo. Para associar códigos de engagements adicionais a um projeto do EY Canvas, use a funcionalidade de arrastar e soltar abaixo.",
		financialCodes: {
			searchButtonTitle: "Procurar",
			searchButtonPlaceholder: "Pesquisar por código financeiro do engagement",
			header: "Códigos do engagement",
			noRecords: "Nenhum código de engagement identificado",
			canvasEngagements: "Engagements do EY Canvas",
			noResults: "Nenhum resultado encontrado"
		},
		canvasEngagements: {
			searchButtonTitle: "Procurar",
			clearButtonTitle: "Limpar",
			noResults: "Nenhum resultado encontrado",
			searchButtonPlaceholder: "Pesquise por cliente ou engagement do EY Canvas",
			header: "Clientes e engagements",
			noRecords: "Nenhum engagement do EY Canvas associado ao projeto",
			noEngagementCodes: "Nenhum código de engagement associado",
			primary: "Primário",
			displayUnassociatedEngagements: "Exibir engagements(s) do EY Canvas sem códigos financeiros associados"
		}
	},
	deleteProject: "Excluir projeto",
	deleteDescription: "Tem certeza de que deseja excluir o projeto para todos os usuários?",
	deleteDescText: "Esta ação não pode ser desfeita.",
	delete: "excluir",
	cancel: "Cancelar",
	close: "Fechar",
	confirm: "Confirmar",
	leaveProject: "Deixar",
	leaveDescription: "Tem certeza que quer deixar esse projeto? Ele continuará disponível para os membros da sua equipe.",
	change: "mudar",
	changes: "Alterações"
};

export const users = {
	settings: {
		title: "User settings",
		firstName: "First name",
		lastName: "Last name",
		displayLanguage: "Display language",
		numberFormat: "Number format",
		negativeNumberFormat: "Negative number format",
		currencyFormat: "Currency format",
		dateFormat: "Date format",
		roundingFormat: "Rounding format",
		save: "Save",
		cancel: "Cancel",
		errorMessageSelect: "Please select a value.",
		errorMessageInput: "Please input a valid value.",
		isRequired: " is required.",
		preferences: "Preferences",
		yourDelegates: "Your delegates",
		yourDelegatesDescription: "Users who you have granted authority to retrieve financial data for engagement codes you have access to in Mercury or GFIS",
		delegationsFromOthers: "Delegation from others",
		delegationsFromOthersDescription: "Users who have granted you authority to retrieve financial data for engagements they have access to in Mercury or GFIS",
		noUsersIdentified: "No users identified",
		addADelegate: "Add a delegate",
		theme: "Theme",
		preferredCurrency: "Preferred currency",
		status: "Status"
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: "Filtrar clientes",
		filter: "filtro",
		searchPlaceholder: "Procurar",
		searchClearHoverText: "claro",
		searchHoverText: "procurar",
		unvalidated: "Não validado",
		noData: "Nenhum engagement do EY Canvas associado",
		noResults: "Nenhum resultado encontrado",
		noInformationAvailable: "Não há informações disponíveis para as opções selecionadas.",
		independence: "Independência",
		noDataFound: "Nenhum dado encontrado"
    },
	roundingType: "Rounding: ",
	roundingFormats: {
		none: "None",
		thousands: "In thousands",
		millions: "In millions",
		lakhs: "In lakhs",
		crores: "In crores"
	},
	updatedDateType: {
		financialDateLabel: "Dados financeiros",
		updatedOn: "atualizado em",
		canvasDateLabel: "Dados do EY Canvas"
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: "TER",
			actualTER: "TER Atual",
			billed: "Faturado",
			actualBilling: "Faturamento real",
			totalEngagementRevenue: "Receita total do engagement (taxas + despesas)",
			forecastedTER: "TER previsto"
		},
		margin: {
			margin: "Margem",
			target: "Target"
		},
		globalDeliveryService: {
			gds: "Uso de GDS",
			globalDeliveryService: "Global Delivery Service"
		}
	},
	currency: "Currency: ",
	globalCurrency: "Global",
	localCurrency: "Local",
	noDataAvailable: "No data available for the selected filters",
	actualHours: "Horas reais",
	etc: "ETC",
	ftaVariance: "Variação de FTA",
	completedTasks: "Tarefas completas",
	closedAssignments: "Tarefas fechadas ",
	acceptedRequests: "Solicitações aceitas",
	gDSUsage: "Uso do GDS",
	summaryHeaderPartner: "Sócio",
	summaryHeaderPpedd: "PPEDD",
	summaryHeaderExecutive: "Executivo",
	financialProgressCard: {
		financialProgress: "Progresso financeiro",
		financialDetails: "Detalhes financeiros",
		ansr: "ANSR",
		nsr: "RPL",
		ansrTooltip: "Receita padrão líquida ajustada (taxas líquidas excluindo despesas)",
		nsrTooltip: "Receita padrão líquida (taxas padrão líquidas individuais multiplicada pelas horas)",
		eafTooltip: "Fator de ajuste do projeto",
		cost: "Custo",
		hours: "Horas",
		expandDetails: "Expandir detalhes",
		expand: "Expandir",
		collapse: "Fechar",
		collapseDetails: "Fechar detalhes",
		margin: "Margem",
		marginPercentage: "Margem",
		rphAcronym: "RPH",
		cphAcronym: "Cph",
		mphAcronym: "Mph",
		eafAcronym: "EAF",
		actual: "atual",
		budgeted: "Orçado",
		forecasted: "Projetado",
		ftaVariance: "Variação de FTA",
		ftaVarianceTooltip: "Projetado vs Variança efetiva",
		rph: "Taxa por hora",
		cph: "Custo por hora",
		mph: "Margem por hora",
		ansrCost: "NSR / Cost",
		serviceLine: "Linha de serviço",
		subServiceLine: "Linha de sub-serviço",
		teamMember: "Membro da equipe",
		totalAnsr: "Total NSR",
		totalCost: "Custo Total",
		totalHours: "Horas Totais",
		ansrLabelText: "Receita líquida padrão",
		rank: "Classificação",
		performanceActuals: "Desempenho atual"
	},
	financialAnalysis: {
		show: "Mostrar",
		first: "Primeiro",
		last: "Último",
		previous: "Anterior",
		next: "Próximo"
	},
	financialFilters: {
		serviceLine: "Linha de serviço",
		subServiceLine: "Linha de sub-serviço ",
		rank: "Classificação",
		teamMember: "Membro da equipe",
		showMore: "Mais",
		clear: "Limpar",
		clearAll: "Apagar tudo",
		search: "Procurar",
		noResultsPlaceholder: "Sem resultados",
		noFiltersAvailable: "Sem filtros",
		yes: "Sim",
		no: "Não",
		tooltip: "Filtro",
		expenseType: "Tipo de despesa"
	},
	billingAndExpenses: {
		title: "Faturamento real até o momento",
		forecastedTer: "TER projetado",
		forecastedTerTooltip: "Receita total prevista de engajamento (taxas + despesas)",
		forecastedBilling: "Faturamento projetado",
		collected: "Recebido",
		collectedTooltip: "Cobrado / Faturado",
		unCollected: "Não coletado",
		unCollectedTooltip: "Não cobrado / Faturado",
		billed: "Faturado (Pendente) ",
		billedTooltip: "TER Faturado / Previsto",
		billedTotal: "Faturado",
		unbilled: "Não faturado",
		unbilledTooltip: "TER Não faturado / Previsto",
		engagementCode: "Código do Engagement",
		invoiceDate: "Data da fatura",
		currency: "Moeda",
		invoiceNumber: "Número da fatura",
		amount: "Valor",
		noInformationPlaceholder: "Nenhuma informação disponível para as opções selecionadas. ",
		actualTer: "TER real",
		actualTerTooltip: "Receita total real do engagement (taxas + despesas)",
		actualExpenseToDate: "Despesas reais até o momento",
		displayBy: "Exibir dados por",
		expenseType: "Tipo de despesa",
		teamMember: "Membro da equipe",
		totalExpenseToDate: "Despesas totais até o momento",
		expenseTypeColumn: "Tipo de despesa",
		teamMemberColumn: "Membro do time",
		globalExpenseAmount: "Valor de despesa global",
		localExpenseAmount: "Valor de despesa local",
		billingSummary: "Resumo de faturamento",
		billingStatus: "Status de faturamento",
		billingTER: "TER",
		serviceLine: " Linha de serviço",
		serviceLineColumn: " Linha de serviço",
		rank: "Classificação",
		rankColumn: "Classificação"
	},
	independence: {
		teamMember: "Membro da equipe",
		hoursCharged: "Horas cobradas",
		independenceStatus: "Status geral de independência",
		confirmationDate: "Data de confirmação",
		memberFirm: "Firma membro",
		eyCanvasIndependenceStatus: "Status de independência do EY Canvas",
		employmentStatus: "Situação de emprego",
		country: "País",
		updatedBy: "Atualizado por",
		updatedDate: "Data atualizada",
		selectColumns: "Selecione as colunas",
		confirmationDateBefore: "Data de confirmação anterior",
		confirmationDateAfter: "Data de confirmação após",
		excelsummary: "Resumo",
		excelMercury: "Dados do Mercury",
		excelCanvas: "Dados do Canvas",
		name: "Nome",
		gui: "GUI",
		rank: "Classificação",
		emailAddress: "Endereço de e-mail",
		clarification: "Esclarecimento",
		explanation: "Explicação",
		updatedOn: "Atualizado em",
		client: "Cliente",
		mercuryEngagementCode: "Código de engagement do Mercury",
		canvasEngagement: "Engagement do Canvas",
		email: "E-mail",
		reason: "Motivo",
		engagementRole: "Papel do Engagement",
		location: "Localização",
		filter: {
			unassociatedFinancialCodes: "Códigos financeiros não associados",
			unassociatedLabel: "Não associado",
			filterHeader: "Filtro de independência",
			noFinancialCodeLabel: "Nenhum código financeiro associado",
			noEngagementLabel: "Nenhum engagement do EY Canvas associado",
			expandText: "Expandir",
			collapseText: "Colapsar",
			noDataFound: "Nenhum dado encontrado"
		}
	},
	header: {
		hours: "Horas",
		actualHours: "Atual",
		forecastedHours: "Previsto",
		variance: "Variação de FTA",
		other: "Outros",
		ppedd: "PPEDD",
		mgrSrMgr: "SrMgr/Mgr",
		partnerHours: "Horas Sócio",
		executiveDirector: "Diretor-executivo ",
		seniorManager: "Senior Manager",
		manager: "Manager",
		senior: "Senior",
		staff: "Staff",
		intern: "Intern",
		billed: "Faturado:",
		ter: "TER:",
		forecastedTER: "TER previsto: ",
		margin: "Margem",
		ansr: "ANSR",
		cost: "Custo",
		terSection: "TER",
		billedSection: "Faturado:",
		forecastedTERSection: "Previsto",
		forecastedTERSectionForHeader: "TER previsto ",
		completedTasks: "Tarefas completas",
		completedAssignments: "Tarefas fechadas ",
		acceptedRequests: "Solicitações aceitas",
		gdsUsage: "Uso de GDS",
		completedTasksTooltip: "Completo",
		totalTasksTooltip: "Total",
		completedAssignmentsTooltip: "Fechado",
		totalAssignmentsTooltip: "Total",
		acceptedRequestsTooltip: "Aceito",
		sentRequestsTooltip: "Enviado",
		gdsHoursTooltip: "GDS",
		actualHoursTooltip: "Horas atuais",
		otherTooltip: "Outros",
		otherHeaderTooltip: "Outros",
		ppeddTooltip: "PPEDD",
		mgrSrMgrTooltip: "SrMgr/Mgr",
		partnerHoursTooltip: "Partner/Principal",
		executiveDirectorTooltip: "ED/D",
		seniorManagerTooltip: "Sr. Manager",
		managerTooltip: "Manager",
		seniorTooltip: "Senior",
		staffTooltip: "Staff",
		internTooltip: "Staff",
		varianceTooltip: "Projetado vs variança efetiva",
		ansrTooltip: "Receita padrão líquida ajustada (taxas líquidas excluindo despesas)",
		marginTooltip: "Margem (ANSR - Custo) / ANSR",
		terSectionHover: "Total da receita atual do engagement ( taxas + despesas)",
		forecastedTERSectionHover: "Total da receita projetada do engagement ( taxas + despesas)",
		billedSectionHover: "Valor líquido efetivo da fatura",
		gdsUsageHover: "Uso do GDS/COE"
	}
};

export const exportOptions = {
	buttonText: "Exportar",
	downloadCSV: "Baixar CSV",
	downloadJPEG: "Baixar JPEG",
	downloadPDF: "Baixe PDF",
	downloadPNG: "Baixar PNG",
	downloadSVG: "Baixar SVG",
	downloadXLS: "Baixar XLS",
	exitFullscreen: "Sair da tela cheia",
	viewFullscreen: "Ver tela cheia",
	printChart: "Imprimir gráfico"
};

export const adminLabels = {
	adminPortal: "Administração",
	usersTab: "Gerenciar usuários",
	projectsTab: "Gerenciar projetos",
	administrators: "Gerenciar administradores"
};

export const projectUserStatus = {
	active: "Ativo",
	inactive: "Inativo"
};

export const projectUserRoles = {
	defaultUser: "Usuário padrão",
	projectAdministrator: "Administrador de projetos"
};

export const projectStatus = {
	active: "Ativo",
	deleted: "Deletado"
};

export const administratorRoles = {
	none: "Nenhum",
	adminReader: "Leitor administrador",
	adminWriter: "Escritor administrador",
	superAdmin: "Super administrador"
}

export const addUser = {
	firstName: "Primeiro nome",
	lastName: "Sobrenome",
	enterFirstNameText: "Digite o primeiro nome, sobrenome ou endereço de e-mail do usuário e pressione enter para pesquisar",
	selectRole: "Função",
	userRole: "Função do usuário",
	clear: "Limpar",
	email: "Email",
	role: "Função",
	cancel: "Cancelar",
	addUser: "Adicionar usuário",
	close: "Fechar",
	add: "Adicionar",
	addAdministrator: "Adicionar administrador",
	error1: "O usuário selecionado já faz parte do projeto. Por favor, revise.",
	error2: "O administrador só pode ser uma conta de usuário privilegiada"
};

export const adminManageProjects = {
	manageProjects: "Gerenciar projetos ",
	description: "Procure um projeto inserindo o ID do projeto ",
	projectId: "ID do projeto",
	search: "Pesquisar",
	clearSearch: "Limpar",
	enterValidProject: "Digite o ID do projeto válido ",
	projectDetails: "Detalhes do projeto",
	enterProjectName: "Digite o nome do projeto ",
	projectName: "Nome do projeto",
	projectStatus: "Status do projeto",
	financialCodes: "códigos financeiros",
	noFinancialCodes: "Nenhum código financeiro do engagement está mapeado para este projeto ",
	engagementCode: "Código do Engagement",
	client: "Cliente",
	status: "Status",
	validatedBy: "Validado por",
	canvasEngagements: "Engagements do EY Canvas",
	canvasEngagement: "Engagement do EY Canvas",
	noCanvasEngagements: "Nenhum engagement do EY Canvas foi mapeado para este projeto",
	member: "Membros",
	gui: "GUI",
	firstName: "Nome",
	lastName: "Sobrenome",
	emailAddress: "Endereço do email ",
	userRole: "Função do usuário",
	validated: "Validado",
	unvalidated: "Não validado ",
	enterValidGui: "Insira uma GUI válido para o ID do projeto",
	requiredProjectName: "O nome do projeto não pode ficar em branco",
	successToastMessage: "Alterações salvas com sucesso",
	resetToastMessage: "Redefinição concluída",
	errorToastMessage: "Pelo menos um membro do projeto deve ser um administrador do projeto. Por favor, revise as alterações.",
	independenceOnly: "Apenas independência",
	yes: "Sim",
	no: "Não"
};

export const manageAdministrators = {
	title: "Gerenciar administradores",
	firstName: "Primeiro nome",
	lastName: "Sobrenome",
	email: "Email",
	role: "Função",
	description: "Adicionar novos administradores ou gerenciar administradores existentes",
	noInformationPlaceholder: "Nenhuma informação disponível para as opções selecionadas.",
	updateAdminErrorToast: "A atualização falhou. Revise e tente novamente mais tarde.",
	updateAdminSuccessToast: "Alterações salvas com sucesso",
};

export const adminManageUsers = {
	title: "Gerenciar usuários",
	description: "Procure um usuário inserindo sua GUI do usuário",
	inputLabel: "GUI do usuário",
	searchButtonLabel: "Buscar",
	cancelButtonLabel: "Limpar",
	errorMessage: "Digite uma GUI de usuário válida",
	userDetails: "Detalhes do usuário",
	projects: "Projetos",
	delegates: "Delegados",
	settings: "Configurações",
	noResultsPlaceholder: "Nenhum registro encontrado",
	delegatedTo: "Delegada para:",
	delegatedFrom: "Delegada de:",
	gui: "GUI",
	firstName: "Primeiro nome",
	lastName: "Sobrenome",
	emailAddress: "Endereço de email",
	projectName: "Nome do projeto",
	projectId: "ID do Projeto"
};

export const adminCommon = {
	save: "Salvar",
	reset: "Redefinir"
}
